import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private modalService: NgbModal) { }

  openModal(componentType: any, componentData?: any) {
    const modalRef = this.modalService.open(componentType);
    if (componentData) {
      Object.assign(modalRef.componentInstance, componentData);
    }
    return modalRef.result;
  }

  openModalWithOptions(componentType: any, options: NgbModalOptions, componentData?: any) {
    const modalRef = this.modalService.open(componentType, options);
    if (componentData) {
      Object.assign(modalRef.componentInstance, componentData);
    }
    return modalRef.result;
  }
}
